/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "@platform/react";
import { Component } from "@platform/react-storybook/Component";
import { useBitmapAsset } from "@front/components/Element/Asset/Bitmap";

import { IconAsset } from "@front/components/Element/Asset/Icon";

import { NAME_POP_UP, TYPE_POP_UP, DEF_POP_UP } from "./types";
import Rules from "./_rules.module.scss";
import type { PropTypesPopUp } from "./types";
import { Button } from "../Button";

export function PopUp(props: PropTypesPopUp) {
    const { bitmap, onClick, ...rest } = props;

    // TODO: update this to get the url of the bitmap and not from hardcoded "pup-up-banner"
    // I don't know how to do it... yet
    const {
        imageData: { "pup-up-banner": bitmapLogo },
    } = useBitmapAsset();

    return (
        <Component
            className={Rules.backgroundView}
            {...rest}
            name={NAME_POP_UP}
            tag="div"
            type={TYPE_POP_UP}
            onClick={onClick}>
            <Button className={Rules.closeButton} onClick={onClick}>
                <IconAsset fill="chile" stroke="chile" uuid="menu-close" />
            </Button>
            <div
                className={Rules.contentView}
                style={{ "background-image": `url(${bitmapLogo})` } as React.CSSProperties}
            />
        </Component>
    );
}
PopUp.defaultProps = DEF_POP_UP;
